import { useId } from "react";
import { Chip, Icon } from "@legal-500/legal500-design-system";
import styles from "./DataProducts.module.css";

type ConfigurationIssuesProps = {
  issues: string[];
};

function ConfigurationIssueList({
  issues,
  className,
}: ConfigurationIssuesProps & { className: string }) {
  return (
    <ul className={className}>
      {issues.map(issue => (
        <li key={issue}>{issue}</li>
      ))}
    </ul>
  );
}

export function DashboardConfigurationBadge({ issues }: ConfigurationIssuesProps) {
  if (issues.length === 0) return null;
  return (
    <>
      <Chip size="small" variant="filled" className={styles.statusWarning}>
        <span className={styles.statusLabel}>
          <span className={styles.statusWarningIcon} aria-hidden="true">
            <Icon icon="exclamation" size="inline" />
          </span>
          Needs configuration
        </span>
      </Chip>
      <ConfigurationIssueList issues={issues} className={styles.issueList} />
    </>
  );
}

export function DashboardConfigurationWarning({ issues }: ConfigurationIssuesProps) {
  const headingId = useId();
  if (issues.length === 0) return null;
  return (
    <section className={styles.configurationWarning} role="status" aria-labelledby={headingId}>
      <h2 id={headingId} className={styles.configurationWarningTitle}>
        This dashboard needs configuration before customers can open it
      </h2>
      <ConfigurationIssueList issues={issues} className={styles.configurationWarningList} />
    </section>
  );
}
